import { useTranslation } from 'react-i18next'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkIfDetailsUpdated = (formData: any, details: any) => {
  const entries1 = Object.entries(formData)
  const entries2 = Object.entries(details)
  console.log('entries1', entries1)
  console.log('entries2', entries2)

  for (const [key, value] of entries1) {
    if (details[key] !== value) {
      return false
    }
  }

  return true
}

export const useSubmitButtonText = (
  drawerType: string,
  displaySeatSelection: boolean,
  isSeatMandatory: boolean,
): string => {
  const { t } = useTranslation()

  if (drawerType === 'edit') {
    if (displaySeatSelection) {
      return t('newBooking.updateBtn')
    }
    if (isSeatMandatory) return t('newBooking.continueEditing')
    else return t('newBooking.updateBtn')
  } else {
    if (displaySeatSelection) {
      return t('newBooking.submitText')
    }
    if (isSeatMandatory) return t('newBooking.continueToSeatSelection')
    else return t('newBooking.submitText')
  }
}
